import { useState } from 'react'
import { theme } from 'antd'
import { DismissibleTooltip } from '../common/DismissibleTooltip'
import { SettingOutlined, CrownOutlined, CrownFilled, TeamOutlined } from '@ant-design/icons'
import { useNavigate } from 'react-router-dom'
import { Logo } from './Logo'
import { ProjectSelector } from './ProjectSelector'
import { UserMenu } from './UserMenu'
import { FeedbackButton } from '../Feedback/FeedbackButton'
import { NotificationBell } from './Notifications/NotificationBell'
import { useProfileContext } from '../../context/profile'
import { useFeatureAccessContext } from '../../context/featureAccess'
import { UpgradePromptModal } from '../UpgradePromptModal/UpgradePromptModal'
import {
  StyledHeader,
  HeaderContent,
  LeftSection,
  RightSection,
  SettingsButton,
  UpgradeButton,
  DashboardButton,
} from './styles/AppHeaderStyles'

const { useToken } = theme

export function AppHeader() {
  const { token } = useToken()
  const navigate = useNavigate()
  const { profile } = useProfileContext()
  const { featureAccess } = useFeatureAccessContext()
  const [showUpgradeModal, setShowUpgradeModal] = useState(false)

  const isAdmin = profile?.role === 'admin' || profile?.role === 'super_admin'
  const isPartner = profile?.role === 'partner'
  const isFreeTier = featureAccess?.tier === 'free'

  return (
    <>
      <StyledHeader $background={token.colorBgContainer} $borderColor={token.colorBorderSecondary}>
        <HeaderContent align="center" justify="space-between">
          {/* Left side - Logo and Project Selector */}
          <LeftSection align="center">
            <Logo />
            <ProjectSelector />
          </LeftSection>

          {/* Right side - Feedback, Settings, Dashboard links, and User Menu */}
          <RightSection align="center">
            {isFreeTier && (
              <UpgradeButton type="primary" onClick={() => setShowUpgradeModal(true)}>
                <CrownFilled />
                <span>Upgrade to Pro</span>
              </UpgradeButton>
            )}
            <FeedbackButton />
            <NotificationBell />
            <SettingsButton
              type="text"
              icon={<SettingOutlined />}
              onClick={() => navigate('/settings')}
            />
            {isPartner && (
              <DismissibleTooltip title="Partner Dashboard">
                <DashboardButton $variant="partner" onClick={() => navigate('/partner')}>
                  <TeamOutlined />
                  <span>Partner</span>
                </DashboardButton>
              </DismissibleTooltip>
            )}
            {isAdmin && (
              <DismissibleTooltip title="Admin Dashboard">
                <DashboardButton $variant="admin" onClick={() => navigate('/admin')}>
                  <CrownOutlined />
                  <span>Admin</span>
                </DashboardButton>
              </DismissibleTooltip>
            )}
            <UserMenu />
          </RightSection>
        </HeaderContent>
      </StyledHeader>

      <UpgradePromptModal isOpen={showUpgradeModal} onClose={() => setShowUpgradeModal(false)} />
    </>
  )
}
